import React, { useState } from 'react';

const Accordion = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {

    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div>
      {data.map((item, index) => (
        <div key={index}>
          <div 
            style={{
              cursor: 'pointer',
              padding: '10px',
              border: '1px solid #24ABE2',
              backgroundColor: '#24ABE2',
              marginBottom: '7px',
              fontWeight:'bold',
              color:'white'
            }}
            onClick={() => handleToggle(index)}
          >
            {item.question}
          </div>
          {activeIndex === index && (
            <div 
              style={{
                padding: '10px',
                border: '1px solid #24ABE2',
                borderTop: 'none',
                backgroundColor: 'lightgray'
              }}
            >
              {item.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;
